
import Vue from "vue";
import bgProgress from "../bg-progress/bg-progress.vue";
import concatUs from "@/components/contact-us/index.vue";
export default Vue.extend({
  name: "regist-success",

  components: {
    concatUs,
    bgProgress,
  },
  data() {
    return {
      submittingEmailMsg: false,
    };
  },
  created() {
    function flexible() {
      var docEl = document.documentElement;
      var dpr = window.devicePixelRatio || 1;

      // adjust body font size
      function setBodyFontSize() {
        if (document.body) {
          document.body.style.fontSize = 12 * dpr + "px";
        } else {
          document.addEventListener("DOMContentLoaded", setBodyFontSize);
        }
      }
      setBodyFontSize();

      // set 1rem = viewWidth / 10
      function setRemUnit() {
        var rem = docEl.clientWidth / 7.5;
        docEl.style.fontSize = rem + "px";
      }

      setRemUnit();

      // reset rem unit on page resize
      window.addEventListener("resize", setRemUnit);
      window.addEventListener("pageshow", function (e) {
        if (e.persisted) {
          setRemUnit();
        }
      });

      // detect 0.5px supports
      if (dpr >= 2) {
        var fakeBody = document.createElement("body");
        var testElement = document.createElement("div");
        testElement.style.border = ".5px solid transparent";
        fakeBody.appendChild(testElement);
        docEl.appendChild(fakeBody);
        if (testElement.offsetHeight === 1) {
          docEl.classList.add("hairlines");
        }
        docEl.removeChild(fakeBody);
      }
    }
    flexible();
  },

  props: {
    can_goback: {
      default: false,
    },

    title: {
      default: "邮箱验证",
    },

    email: {
      default: "",
    },

    text1: {
      default: "激活邮件发送成功",
    },

    text2: {
      default: "邮箱发送有1~3分钟延迟，请耐心等候",
    },

    text3: {
      default: "我们已将验证信息发送至您的邮箱：",
    },

    text4: {
      default: "请前往邮箱进行验证，进入审核流程",
    },

    isActived: {
      default: false,
    },
    success: {
      default: true,
    },
    loading: {
      default: false,
    },
    step: {
      type: [Number, String],
      default: 1,
    },
  },

  mounted() {
    sessionStorage.removeItem("supplierBase");
    //this.$setTitle("邮箱验证");
  },
  methods: {
    resubmitEmailMsg() {
      //
    },
  },
});
